import SimpleInfoModal from './SimpleInfoModal'

export default SimpleInfoModal


// WEBPACK FOOTER //
// app/javascript/components/SimpleInfoModal/index.js